import React from "react";
import "./CampusCss/SayalaCampus.css";

const SayalaCampus = () => {
  return (
    <div className="gurukul-containerTS">

      {/* Header Section */}
      <header className="headerTS">
        <div className="header-contentTS">
          <h1> Shri Kheteshwar Gurukul</h1>
          <h2>Tura Sayala, Jalore, Rajasthan</h2>
          <div className="header-decorationTS"></div>
        </div>
      </header>

      {/* Introduction */}
      <section className="introTS">
        <div className="intro-contentTS">
          <div className="intro-textTS">
            <h2>Nurturing Young Minds Since 2023</h2>
            <p>
              Established in the academic year <strong>2023-24</strong>, our Gurukul follows the unique classification system of <strong>"Arun Class" to "Panchami Class"</strong> (equivalent to grades 1-8). 
              With <strong>145+ students</strong>, we provide education under the <strong>Rajasthan Board of Secondary Education</strong>.
            </p>
            <div className="feature-gridTS">
              <div className="feature-boxTS">
                <div className="feature-iconTS">🧘</div>
                <h4>Daily Yoga</h4>
              </div>
              <div className="feature-boxTS">
                <div className="feature-iconTS">🎨</div>
                <h4>Art & Craft</h4>
              </div>
              <div className="feature-boxTS">
                <div className="feature-iconTS">🌱</div>
                <h4>Eco Club</h4>
              </div>
            </div>
          </div>
          <img src="/sawai.jpg" alt="Tura Sayala Gurukul" className="main-imageTS" />
        </div>
      </section>

      {/* Class System */}
      <section className="classesTS">
        <div className="section-headerTS">
          <h2>🏫 Our Unique Class System</h2>
          <p className="section-subtitleTS">Traditional names with modern education</p>
        </div>
        <div className="class-systemTS">
          <div className="class-columnTS">
            <h3>Morning Classes</h3>
            <ul>
              <li>Arun Class (Grade 1)</li>
              <li>Uday Class (Grade 2)</li>
              <li>Prabhat Class (Grade 3)</li>
            </ul>
          </div>
          <div className="class-columnTS">
            <h3>Main Classes</h3>
            <ul>
              <li>Prathama Class (Grade 4)</li>
              <li>Dvitheeya Class (Grade 5)</li>
              <li>Triteeya Class (Grade 6)</li>
            </ul>
          </div>
          <div className="class-columnTS">
            <h3>Senior Classes</h3>
            <ul>
              <li>Chaturthi Class (Grade 7)</li>
              <li>Panchami Class (Grade 8)</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Achievements */}
      <section className="achievementsTS">
        <div className="section-headerTS">
          <h2>🏆 Our Achievements</h2>
        </div>
        <div className="achievement-cardsTS">
          <div className="achievement-cardTS">
            <h3>First Year</h3>
            <p>Started with 80 students in temporary facilities</p>
          </div>
          <div className="achievement-cardTS">
            <h3>Second Year</h3>
            <p>Expanded to 145 students with new classrooms</p>
          </div>
          <div className="achievement-cardTS">
            <h3>Future Plans</h3>
            <p>Construction of permanent building underway</p>
          </div>
        </div>
      </section>


    </div>
  );
};

export default SayalaCampus;